import styled, { css } from 'styled-components';

export const StyledForwardIcon = styled.svg`
  position: absolute;
  width: 16px;
  height: 16px;
  right: 8px;
  top: 50%;
  margin-top: -8px;
  color: ${({ theme }) => theme.colors.gray13};
`;

export const StyledMenuItem = styled.div<{
  isSelected?: boolean;
  disabled?: boolean;
}>`
  position: relative;
  display: block;
  color: ${({ theme }) => theme.colors.text};
  background: ${({ theme }) => theme.colors.white};
  border: 0;
  min-height: 40px;
  padding: 11px 12px;
  box-sizing: border-box;
  cursor: pointer;
  user-select: none;
  width: 100%;
  text-decoration: none;
  min-width: 286px;
  text-align: left;

  ${({ isSelected }) => isSelected && css`
    background: ${({ theme }) => theme.colors.blue12};
    color: ${({ theme }) => theme.colors.light};
    z-index: 1;

    ${StyledForwardIcon} {
      color: ${({ theme }) => theme.colors.light};      
    }
  `}

  ${({ disabled }) => !disabled && css`
    &:hover {
      background: ${({ theme }) => theme.colors.blue12};
      color: ${({ theme }) => theme.colors.light};

      ${StyledForwardIcon} {
        color: ${({ theme }) => theme.colors.light};      
      }
    }

    &:active {
      background: ${({ theme }) => theme.colors.blue14};
      color: ${({ theme }) => theme.colors.primary};

      ${StyledForwardIcon} {
        color: ${({ theme }) => theme.colors.primary};      
      }
    }
  `}

  ${({ disabled }) => disabled && css`
    color: ${({ theme }) => theme.colors.disabled};    
    cursor: default;

    ${StyledForwardIcon} {
      color: ${({ theme }) => theme.colors.disabled};      
    }
  `}
`;
